import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

const publicUrl = process.env.PUBLIC_URL || ".";
// Compute pathname from PUBLIC_URL ('.' -> '/')
const basename = new URL(publicUrl, window.location.origin).pathname || "/";

ReactDOM.render(
  <BrowserRouter basename={basename}>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

serviceWorker.register();
